import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { DataTablesModule } from 'angular-datatables';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { ToastModule } from 'app/toast/toast.module';
import { WebHookListComponent } from './components/web-hook-list/web-hook-list.component';
import { FailedTransactionsActionCellComponent } from './components/failed-transactions-action-cell/failed-transactions-action-cell.component';
import { WebhookCardComponent } from './components/webhook-card/webhook-card.component';
import { ManageWebhookDetailsComponent } from './components/manage-webhook-details/manage-webhook-details.component';
import { StoreModule } from '@ngrx/store';
import * as fromWebHook from './features/webhook-reducer'
@NgModule({
  declarations: [
    WebHookListComponent,
    WebhookCardComponent,
    ManageWebhookDetailsComponent,
    WebhookDetailsListComponent,
  ],
  imports: [
    StoreModule.forFeature(fromWebHook.webHookFeatureKey, fromWebHook.reducer),
    EffectsModule.forFeature([WebHookEffects]),
    CommonModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    MdbFormsModule,
    MdbTabsModule,
    ToastModule,
    DataTablesModule,
    FailedTransactionsActionCellComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    WebHookListComponent
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class IntegrationMonkeyModule { }import { WebHookEffects } from './features/webhook-effects';
import { EffectsModule } from '@ngrx/effects';
import { WebhookDetailsListComponent } from './components/webhook-details-list/webhook-details-list.component';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';

